module.exports = ".badge-panel {\n  display: inline-block;\n  width: 100%;\n  padding: .4em;\n  border: 1px solid #dbdcdc;\n  border-radius: 2px; }\n"